import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchSettings } from "../lib/api";

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const reload = useCallback(() => {
    return fetchSettings()
      .then(setSettings)
      .catch(() => setSettings({}));
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  // Auto-refresh when the tab becomes visible again or window regains focus.
  // This makes dashboard changes appear live on the public site as soon as you switch tab.
  useEffect(() => {
    const onVisible = () => {
      if (document.visibilityState === "visible") reload();
    };
    const onFocus = () => reload();
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", onFocus);
    return () => {
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", onFocus);
    };
  }, [reload]);

  return (
    <SettingsContext.Provider value={{ settings: settings || {}, loaded: settings !== null, reload }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext) || { settings: {}, reload: () => {} };
